var cbtUtil = require("../cbtUtil");
var cbtProductCarousel = require("./cbtProductCarousel");
var $cache = {};

/**
 * Initiates cache
 */
function initCache() {
    $cache.document = $(document);
}

function cbtBrandClickEvent() {
    $cache.document.on("click", ".cbt-brands", function() {
        var $this = $(this);
        var brandValue = $this.data("en");
        var carouselId = $this.attr("href");
        var $carouselWrapper = $this.parents(".tab-carousel-wrapper");
        var carouselTitle = $carouselWrapper.find(".section-title").data("en");
        var listName = brandValue ? carouselTitle + " - " + brandValue : carouselTitle;
        var $carousel = $(carouselId);
        $carousel.on("init", function () {
            var dataLayer1 = cbtProductCarousel.getHomePageProductListDataLayer($carousel, listName);
            if (dataLayer1.products.length) {
                cbtUtil.dataPush(dataLayer1);
            }
        });
        var dataLayer2 = {
            "event": "brandLinkClick",
            "brandLinkName": brandValue
        };
        cbtUtil.dataPush(dataLayer2);
    });
}

function cbtJournal19ClickEvent() {
    $cache.document.on("click", ".cbt-journal19", function() {
        const $this = $(this);
        const journal19Value = $this.data("en");
        const dataLayer = {
            "event": "journalLinkClick",
            "journalLinkName": journal19Value
        };

        cbtUtil.dataPush(dataLayer);
    });
}

window.addEventListener("load", function () {
    initCache();
    cbtBrandClickEvent();
    cbtJournal19ClickEvent();
});
